<template>
  <div v-if="someCartAdditionsFailed" class="cart-additions-failed">
      <div v-if="successfullyAddedTicketTypes.length > 0">
        <h3>{{ $t('ticket.successfully_added_to_cart') }}</h3>
        <ul>
          <li v-for="item in successfullyAddedTicketTypes">
            <font-awesome-icon icon="check-circle"/>{{ item.priceClassAlias.priceClassAlias }}
          </li>
        </ul>
      </div>
      <div v-if="failedToAddTicketTypes.length > 0">
        <h3>{{ $t('ticket.failed_to_add_to_cart') }}</h3>
        <ul>
          <li v-for="item in failedToAddTicketTypes">
            <font-awesome-icon icon="exclamation-triangle" class="error-item_icon" />{{ item.priceClassAlias.priceClassAlias }}
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: 'cart-additions-failed',
  props: {
    // Doesn't need to be true; could just be adding one ticket which fails
    successfullyAddedTicketTypes: {
      type: Array,
      required: false
    },
    failedToAddTicketTypes: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters(['someCartAdditionsFailed'])
  }
}
</script>

<style>

</style>